module.exports = __webpack_public_path__ + "images/demo/shop_dummy_1b4efe96b32922a462cd9ccc2e459d36.jpg";